<template>
  <div class="common-box CustomerManagement">
    <div>
      <el-form
        inline
        ref="form"
        class="search-form common-box-search-form"
        label-position="right"
        :model="form"
        label-width="70px"
      >
        <search-form @search="handleSearch" @refresh="handleRefresh">
          <div slot="content">
            <el-form-item label="消息类型：">
              <el-select size="mini" v-model="form.msgType" value-key="dictionaryCode">
                <el-option
                  v-for="item in WXMBXXDicts"
                  :key="item.dictionaryCode"
                  :label="item.dictionaryValue"
                  :value="item.dictionaryCode"
                  placeholder="请选择消息类型"
                    @change="handleSearchListData"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </search-form>
      </el-form>
    </div>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
      </div>
      <div class="table__container">
        <el-table
          v-loading="tableLoading"
          :data="list"
          height="100%"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="projectName"
            label="项目名称"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="liftLocation"
            label="电梯位置"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="customerName"
            label="客户名称"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="customerPhone"
            label="联系方式"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="username"
            label="用户名称"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="msgType"
            label="消息类型"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="sendStatusMsg"
            label="推送结果"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="createTime"
            label="推送时间"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="content"
            label="发送文本"
            width="150"
          ></el-table-column>

          <el-table-column label=" " prop=" "></el-table-column>
          <el-table-column label="操作" width="50px" fixed="right">
            <template slot-scope="scope">
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getTemplateMessageList
} from "@/api/CustomerFollowManagement";
import { mapState } from "vuex";
export default {
  name: "CustomerFollowManagement",
  components: {
  },
  data() {
    return {
      form: {
        customerName: null,
        msgType: null,
      },
      tableLoading: false,
      list: [],
      multipleSelection: [],
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      showAddUser: false,
      userDetail: null,
      showCode: false,
      url: "",
    };
  },
  computed: {
    hasRole: function () {
      return this.$store.getters["common/promise/getRole"](this.$route.path);
    },
    ...mapState("common/dictionary", ["WXMBXXDicts"]),
  },
  created() {
    this.getListData();
  },
  methods: {
    getParams() {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      return params;
    },
    async getListData() {
      const params = await this.getParams();
      const res = await getTemplateMessageList(params);
      if (res.code === 200) {
        this.list = res.data.list;
        this.total = res.data.total;
      }
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleRefresh() {
      for (let key in this.form) {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else {
          this.form[key] = "";
        }
      }
      this.pageIndex = 1;
      this.getListData();
    },
    handleSearchListData() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleEdit(row) {
      this.userDetail = row;
      this.showAddUser = true;
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getListData();
    },
    deleteContractMore(row) {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择要删除的行");
        return;
      }
      let idList = this.multipleSelection.map((item) => item.id);
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deletePermissionLift({ idList });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteContract(row) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deletePermissionLift({ idList: [row.id] });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss">
.CustomerManagement {
  .el-radio-group {
    margin-bottom: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/WxTemplatePushManagement/WxTemplatePushManagement.vue